import { CommandTemplate } from '../../../../core/entities/commandTemplate/commandTemplate';
import { HasCommands } from '../../../../core/services/command/command.service';
import { LineItem } from "../lineItem/lineItem";
import { Protocol } from "../protocol/protocol";
import { Resource } from "../resource/resource";
import { SchedulingInformation } from "../schedulingInformation/schedulingInformation";
import { PrimeNGSeverity } from "../../../../shared-module/shared/types/primeng-severity.type";

export class ResourceAssignment implements HasCommands{

  static ENTITY_TYPE: string = 'ResourceAssignment';

  id: string | undefined;
  externalId: string | undefined;
  name: string;
	isDeletable: boolean;
	lineItem: LineItem
	startDateTime: string;
	endDateTime: string;
	resource: Resource
	free: Boolean
	state: ResourceAssignmentState
	schedulingInformation: SchedulingInformation;
  effectiveSchedulingInformation: SchedulingInformation;
  protocols: Protocol[];
	customAttributes: any[]
  text: string;
  commands: CommandTemplate[];


  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.extensions;
      this.name = payload.name;
      this.startDateTime = payload.startDateTime;
      this.isDeletable = payload.isDeletable;
      this.endDateTime = payload.endDateTime;
      this.free = payload.free;
      this.text = payload.text;
      if (payload.lineItem) {
        this.lineItem = new LineItem(payload.lineItem);
      }
      if (payload.resource) {
        this.resource = new Resource(payload.resource);
      }
      this.state = payload.state;
      if (payload.schedulingInformation) {
        this.schedulingInformation = new SchedulingInformation(payload.schedulingInformation);
      }
      if (payload.effectiveSchedulingInformation) {
        this.effectiveSchedulingInformation = new SchedulingInformation(payload.effectiveSchedulingInformation);
      }
      if(payload.protocols && payload.protocols.length > 0) {
        this.protocols = new Array<Protocol>();
        payload.protocols.map( (protocol : any) => {
          this.protocols.push(new Protocol(protocol));
        })
      }
      this.customAttributes = payload.customAttributes;
      if(payload.commands){
        this.commands = new Array<CommandTemplate>();
        payload.commands.map( (command: any) => {
          this.commands.push(new CommandTemplate(command));
        })
      }
    }
  }
  getEntityType(): string {
    return ResourceAssignment.ENTITY_TYPE;
  }

  getCollectionRoute(): string {
    return undefined;
  }

  getEntityId(): string {
    return this.id || undefined;
  }

  getResourceAssignmentStateSeverity(): PrimeNGSeverity | undefined {
    return ResourceAssignment.getResourceAssignmentStateSeverity(this.state + "");
  }

  getResourceAssignmentState(): string {
    return ResourceAssignment.getResourceAssignmentStateStatic(this.state + "");
  }

  /**
   * creates models from a result
   * @param result Array of any
   * @returns Bookigs
   */
  static createResourceAssignments(result: Array<any>): ResourceAssignment[] {
    const resources = new Array<ResourceAssignment>();
    if (result) {
      result.map((resource) => {
        resources.push(new ResourceAssignment(resource));
      });
    }
    return resources;
  }

  static getResourceAssignmentStateStatic(state: string): string {
    switch (state) {
      case 'NEW':
        return 'rentModule.resourceAssignment.new';
      case 'OUT':
        return 'rentModule.resourceAssignment.out';
      case 'IN':
        return 'rentModule.resourceAssignment.in';
      case 'COMPLETED':
        return 'rentModule.resourceAssignment.completed';
      case 'ARCHIVED':
        return 'rentModule.resourceAssignment.archived';
      case 'RUNNING':
        return 'rentModule.resourceAssignment.running';
      default:
        return '-';
    }
  }

  static getResourceAssignmentStateSeverity(state: string): PrimeNGSeverity | undefined {
    switch (state) {
      case 'NEW':
        return 'info';
      case 'OUT':
        return 'warning';
      case 'IN':
        return 'success';
      case 'COMPLETED':
        return 'success';
      case 'ARCHIVED':
        return 'info';
      case 'RUNNING':
        return 'warning'; 
      default:
        return undefined;
    }
  }
}

export class ResourceAssignmentInput {
  id: string;
  externalId: string;
  name: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.name = payload.name;
    }
  }
}

export enum  ResourceAssignmentState {
	OPEN, OUT_SCHEDULED, OUT, IN_SCHEDULED, IN, COMPLETED
}

